"use client";

import dynamic from "next/dynamic";

const Silk = dynamic(() => import("@/components/Silk"), { ssr: false });

export function SilkBackground() {
  return (
    <div className="absolute inset-0 z-0">
      <Silk
        speed={3.8}
        scale={0.8}
        color="#f2fe0f"
        noiseIntensity={0.7}
        rotation={1.7}
      />
    </div>
  );
}
